import React, { useCallback } from "react";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { Product3dViewModal } from "components/_Modals/Product3dViewModal/Product3dViewModal";
import { Button } from "components/Button";
import { useTranslate } from "hooks";
import { ImageDropdownWithSlider } from "../ImageDropdownWithSlider";
import s from "../../ProductConfiguratorComponent.module.scss";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";

export const TechnicalDesignMedia = ({ images, requestParams }) => {
  const { product } = useProductConfiguratorStore.use.productData() || {};
  const translate = useTranslate();

  const isProductAccessory = !!product?.accessoryInfo?.accessoryId;

  const handleToggle3dView = useCallback(() => {
    NiceModal.show(Product3dViewModal, {
      requestParams,
    });
  }, [requestParams]);

  const button3dView = (
    <Button
      data-testid="open-3dview-btn"
      className="w-100"
      icon="3-d-symbol-regular"
      iconPrefix="trox"
      onClick={handleToggle3dView}
      color="outline-dark"
      disabled={isProductAccessory}
    >
      {translate("PRODUCT_CONFIGURATOR_TO_3D_VIEW")}
    </Button>
  );

  return (
    <div
      className={cx(
        "d-flex flex-column flex-grow-1 min-h-0 overflow-hidden",
        s.mediaWrapper,
      )}
    >
      <div className="flex-grow-1 mb-3 min-h-0 overflow-hidden">
        <ImageDropdownWithSlider
          images={images}
          button3dView={button3dView}
          isDisabled={isProductAccessory}
        />
      </div>

      <div className={s.bottomButton}>{button3dView}</div>
    </div>
  );
};
